export default "__VITE_ASSET__Bi7Kwnql__"